import "./App.scss";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { advantageRoutes } from "./routing/AdvantageRouteObjects";
import { agilityRoutes } from "./routing/AgilityRouteObjects";
import { apexRoutes } from "./routing/ApexRouteObjects";
import { chmRoutes } from "./routing/CambioRouteObjects";
import { celeriRoutes } from "./routing/CeleriRouteObjects";
import { celinkRoutes } from "./routing/CelinkRouteObject";
import { demoRoutes } from "./routing/DemoRouteObjects";
import { fcmRoutes } from "./routing/FCMRouteObjects";
import { flexpointRoutes } from "./routing/FlexpointRouteObjects";
import { grateRoutes } from "./routing/GRateRouteObjects";
//import { hmdaRoutes } from "./routing/HMDARouteObjects";
import { kindLendingRoutes } from "./routing/KindLendingRouteObjects";
import { pmgRoutes } from "./routing/PanoramaRouteObjects";
import { prmgUATModeRoutes, prmgProdRoutes } from "./routing/PRMGRouteObjects";
import { radiusRoutes } from "./routing/RadiusRouteObjects";
import { reliantRoutes } from "./routing/ReliantRouteObject";
import { revolutionRoutes } from "./routing/RevolutionRouteObjects";
//import { rocketRoutes } from "./routing/RocketRouteObjects";
//import { adminMenuRoutes } from "./routing/AdminRouteObjects";
import { northernMortgageRoutes } from "./routing/NorthernMortgageRouteObjects";
import { mainRoutes, landingPageRoutes } from "./routing/MainRoutes";
import { RouterError } from "./components/RouterError";
import { loanStoreRoutes } from "./routing/LoanStoreRouteObjects";
import { dinerCapRoutes } from "./routing/DinerCapRouteObjects";
import { chmuatRoutes } from "./routing/CambioUATRouteObject";

const router = createBrowserRouter([
  {
    errorElement: <RouterError />,
  },
  //adminMenuRoutes,
  advantageRoutes,
  //agilityRoutes,
  apexRoutes,
  celeriRoutes,
  celinkRoutes,
  chmRoutes,
  demoRoutes,
  fcmRoutes,
  flexpointRoutes,
  grateRoutes,
  //hmdaRoutes,
  kindLendingRoutes,
  landingPageRoutes,
  mainRoutes,
  northernMortgageRoutes,
  pmgRoutes,
  prmgProdRoutes,
  prmgUATModeRoutes,
  radiusRoutes,
  reliantRoutes,
  revolutionRoutes,
  //rocketRoutes,
  loanStoreRoutes,
  dinerCapRoutes,
  chmuatRoutes,
]);

export default function App() {
  return <RouterProvider router={router} />;
}
